<!--
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: xiaobai
 * @Date: 2021-06-10 17:30:51
 * @LastEditors: 小白
 * @LastEditTime: 2022-10-13 13:31:33
 * @FilePath: /fujian-official-website/src/components/footer.vue
-->
<template>
  <div class="content footer_box">
    <div class="content_1260">
      <div class="el-row">
        <div class="el-col el-col-24 el-col-sm-24 el-col-md-24 el-col-lg-24">
          <div class="footer_text">
            <span class="mr-30">
              <i class="el-icon-phone mr-10"></i>
              <span>联系电话：{{contact.mobile}}</span>
            </span>
            <span class="mr-30">
              <i class="el-icon-message mr-10"></i>
              <span>电子邮箱：{{contact.email}}</span>
            </span>
            <span class="mr-30">
              <i class="el-icon-location-information mr-10"></i>
              <span>公司地址：{{contact.address}}</span>
            </span>
          </div>
          <div class="mt-20">
            <span> CopyRight © 2022 福建省闽西交通工程有限公司 </span>
            <span>All Right Reserved. | <span @click="openPage()">闽ICP备2022009678号-1</span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return{
      contact:{}
    }
  },
  mounted(){
    this.getContact()
  },
  methods:{
    getContact(){
      axios.post('/home/contact/us', {}).then((res) => {
        this.contact = res.data.data.contactUs
      })
    },
    openPage(){
      window.open('https://beian.miit.gov.cn/')
    }
  }
  
}
</script>

<style>
</style>